






































































































import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants.ts";
import DashboardFilterComponent from "./Filter/DashboardFilter.vue";
import { http } from "@/shared/https";
import AuthService from "@/services/auth.service";
import { Utilities as utils } from "@/shared/utilities";
import { Locales } from "@/i18n/locales";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";
import { ReviewForm } from "@/entities";

const auth = new AuthService();
const namespace: string = "reviewExternal";

@Component({
  components: {
    DashboardFilterComponent,
  },
})
export default class ExternalReviewerList extends Vue {
  @State("reviewForm") review!: ReviewForm;
  @Action("getData", { namespace: "reviewForm" }) getData: any;
  @Action("getCategories", { namespace: "reviewForm" }) getCategories: any;
  @Action("setApplicationId", { namespace }) setApplication: any;
  @Action("setApplicationId", { namespace: "application" })
  setApplicationId: any;
  @Action("setReviewId", { namespace }) setReiewId: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("_appUserId", { namespace: "RootApp" }) _userid!: number;
  @Prop() items: any;
  @Prop() entity!: any;

  collapsed = false;
  countLoop: number = 0;
  dataLength: number = 0;
  Edit: boolean = true;
  defaultData: Array<any> = [];
  uploadReady: boolean = true;
  readonlyStatus = [
    _app.reviewStatus.COI_Rejected,
    _app.reviewStatus.Submitted,
  ];
  inProgressStatus = [_app.reviewStatus.In_Progress];
  disagreeStatus = _app.reviewStatus.COI_Rejected;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  data() {
    var self = this;
    return { calls: self.items, Edit: self.Edit };
  }

  mounted() {}

  /** Start review of the application */
  startReview(item) {
    var self = this;
    // gets current user id
    auth.getUser().then((user) => {
      if (user !== null) {
        this.$router.push({
          name: "reviewApplication",
          params: {
            reviewerId: user.profile.sub,
            applicationId: item.uniqueID,
            entity: self.entity
          },
        });
      }
    });
  }

  /** Download Pdf*/
  downloadPdf(item: any) {
    let self = this;
    let categoryList = [],
      modelData,
      formData;
    if (item.ExternalReviewId) {
      this.$services.review
        .getReportData(item.ExternalReviewId, this.entity)
        .then((resp) => {
          if (resp.status >= 200 && resp.status < 300) {
            this.getCategories({ id: item.ApplicationId, entity: self.entity }).then((catg) => {
              self.$services.tagReviewReport.generate({
                data: resp.data.review,
                categories: catg,
                metadata: resp.data.metadata,
                user: self._username,
              });
            });
          }
        });
    }
  }

  viewReview(item: any) {
    if (item !== null) {
        let routeData = this.$router.resolve({
          name: "viewTagReview",
          query: { reviewerId: item.ReviewerId,
          applicationId: item.uniqueID, entity: this.entity }
        });
        window.open(routeData.href, "_blank");
      }
  }

  formatCurrency(val, currency) {
    if (typeof(val) === "string") {
      return val;
    }
    return utils.formatCurrency(val, currency, this.defaultLocale);
  }

  getFormData(model) {
    const reviews = Object.keys(model).reduce((out: any, key: string) => {
      out.push(Object.assign({}, { categoryId: parseInt(key) }, model[key]));
      return out;
    }, []);
    let form = {
      reviews,
      override: this.review.override,
      comment: this.review.comment,
      // totalScore: this.overallScore,
      overallRating: this.review.overallRating,
      recommendation: this.review.recommendation,
      applicationId: this.review.applicationId,
      reviewerId: this.review.reviewerId,
      version: this.review.version,
      auditInfo: this.review.auditInfo,
    };

    return form;
  }
}
